import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Badge } from 'antd';
import { localStorageGet } from '@/core/cookie';
import { menuItems } from './data/menuItems';

function buildHealthclassMenuItems(subMenuList, count) {
    const top = [];
    if (Array.isArray(subMenuList) && subMenuList.length > 0) {
        subMenuList.forEach(item => {
            const childSubMenus = [];
            if (item.childList?.length) {
                item.childList.forEach(elem => {
                    const elemChildren = [];
                    if (elem.resourceList?.length) {
                        elem.resourceList.forEach(element => {
                            if (element.type === 1) {
                                elemChildren.push({ key: element.route || `hc-leaf-${element.id}-${element.name}`, label: <Link to={element.route}>{element.name}</Link> });
                            }
                        });
                    }
                    childSubMenus.push({ key: elem.route || `hc-sub-${elem.id}-${elem.name}`, label: elem.name, ...(elemChildren.length ? { children: elemChildren } : {}) });
                });
            }
            const directItems = [];
            if (item.resourceList?.length) {
                item.resourceList.forEach(elem => {
                    if (elem.type === 1) {
                        directItems.push({
                            key: elem.route || `hc-direct-${elem.id}-${elem.name}`,
                            label:
                                elem.name === '学苑审核' ? (
                                    <Link to={elem.route}>
                                        <Badge count={count} offset={[20, 5]}>
                                            {elem.name}
                                        </Badge>
                                    </Link>
                                ) : (
                                    <Link to={elem.route}>{elem.name}</Link>
                                ),
                        });
                    }
                });
            }
            top.push({ key: item.route || `hc-top-${item.id}-${item.name}`, label: item.name, children: [...childSubMenus, ...directItems] });
        });
    }
    return [
        ...top,
        {
            key: 'healthclass-clue',
            label: '线索管理',
            children: [{ key: '/healthclass/clue', label: <Link to="/healthclass/clue">咨询用户</Link> }],
        },
    ];
}

/**
 * 计算当前路径和权限下的有效菜单项，供 AppSider 和移动端 Drawer 共用。
 */
export function useEffectiveMenuItems({ pathname, subMenuList, healthclassSubMenuList, healthclassOrgCount }) {
    const canViewEvalResult = useMemo(() => {
        const raw = localStorageGet('roleList');
        if (!raw) return false;
        try {
            const roleList = JSON.parse(raw);
            return Array.isArray(roleList) && roleList.some(item => item.name === '查看专家综评结果');
        } catch {
            return false;
        }
    }, []);

    return useMemo(() => {
        return menuItems.map(item => {
            if (item.key === 'dc') {
                return {
                    ...item,
                    children: item.children.map(child => {
                        if (child.key === 'expert-data') {
                            return {
                                ...child,
                                children: [{ key: '/dc/experts', label: '专家管理' }, ...(canViewEvalResult ? [{ key: '/dc/experts-evaluation', label: '专家价值' }] : [])],
                            };
                        }
                        return child;
                    }),
                };
            }
            if (item.key === 'healthclass') {
                if (!Array.isArray(healthclassSubMenuList) || healthclassSubMenuList.length === 0) {
                    return item;
                }
                return { ...item, children: buildHealthclassMenuItems(healthclassSubMenuList, healthclassOrgCount) };
            }
            return item;
        });
    }, [canViewEvalResult, pathname, subMenuList, healthclassSubMenuList, healthclassOrgCount]);
}
